import { arrayOf, func, number } from 'prop-types';
import React from 'react';

import { campaignShape, commentShape } from '../../prop-types';
import Comment from '../Comment.container';
import CommentEditor from '../CommentEditor.container';

function Comments({ comments, onAddComment, preferableMentions, campaign }) {
  return (
    <>
      <CommentEditor
        onClick={onAddComment}
        preferableMentions={preferableMentions}
      />
      {comments.map(comment => (
        <Comment
          key={comment.id}
          model={comment}
          preferableMentions={preferableMentions}
          campaign={campaign}
        />
      ))}
    </>
  );
}

Comments.propTypes = {
  comments: arrayOf(commentShape).isRequired,
  onAddComment: func.isRequired,
  preferableMentions: arrayOf(number),
  campaign: campaignShape.isRequired,
};

Comments.defaultProps = {
  preferableMentions: [],
};

export default Comments;
